
<template>
    <div class="page">
      <v-container fluid>
        <v-form ref="form">
            <div v-if="form.filters.analitico">
                <v-row class="d-flex justify-center mt-3">
                    <v-col cols="2">
                        <v-autocomplete
                            v-model="form.filters.greIdAnalitico"
                            label="GRE"
                            dense
                            outlined
                            item-text="nome"
                            item-value="codigo"
                            return-object
                            :items="form.lists.listaGerenciasRegionais"
                        />
                    </v-col>
                    <v-col cols="3">
                        <v-autocomplete
                            v-model="form.filters.disciplinaAnalitico"
                            label="Disciplina"
                            dense
                            outlined
                            :items="form.lists.listaDisciplinas"
                            item-text="nomeDisciplina"
                            item-value="id"
                        />
                    </v-col>
                    <v-col cols="3">
                        <v-autocomplete
                            v-model="form.filters.tipoDisciplinaAnalitico"
                            :items="form.lists.tiposDeDisciplina"
                            label="Tipo de Disciplina"
                            item-text="tipoDisciplina"
                            item-value="id"
                            outlined
                            dense
                        ></v-autocomplete>
                    </v-col>
                    <sigfoco-select-ativo
                        :cols="3"
                        v-model="form.filters.situacao"
                        labelType="Situação"
                    ></sigfoco-select-ativo>
                </v-row>
                <v-row class="d-flex justify-center mt-3">
                    <sigfoco-date-picker
                    :cols="2"
                    label="Data Início"
                    v-model="form.filters.dataInicioAnalitico"
                    removeIcon
                    outlined
                    dense
                    ></sigfoco-date-picker>
                    <sigfoco-date-picker
                    :cols="2"
                    v-model="form.filters.dataFimAnalitico"
                    label="Data Final"
                    removeIcon
                    outlined
                    dense
                    ></sigfoco-date-picker>
                    <sigfoco-switch-button
                        :cols="2"
                        v-model="form.filters.analitico"
                        label="Tipo de Relatório"
                        labelChecked="Analítico"
                        labelUnchecked="Sintético"
                    ></sigfoco-switch-button>
                </v-row>
            </div>
            <div v-else>
                <v-row class="d-flex justify-center mt-3">
                    <v-col cols="3">
                        <v-autocomplete
                            v-model="form.filters.disciplinaSintetico"
                            label="Disciplina"
                            dense
                            outlined
                            :items="form.lists.listaDisciplinas"
                            item-text="nomeDisciplina"
                            item-value="id"
                        />
                    </v-col>
                    <sigfoco-date-picker
                        :cols="2"
                        label="Data Início"
                        v-model="form.filters.dataInicioSintetico"
                        removeIcon
                        outlined
                        dense
                    ></sigfoco-date-picker>
                    <sigfoco-date-picker
                        :cols="2"
                        v-model="form.filters.dataFimSintetico"
                        label="Data Final"
                        removeIcon
                        outlined
                        dense
                    ></sigfoco-date-picker>
                    <sigfoco-switch-button
                        :cols="2"
                        v-model="form.filters.analitico"
                        label="Tipo de Relatório"
                        labelChecked="Analítico"
                        labelUnchecked="Sintético"
                    ></sigfoco-switch-button>
                </v-row>
            </div>
            <div class="text-center">
                <v-col cols="12">
                    <sigfoco-tooltip
                        text="Buscar"
                        icon="mdi-magnify"
                        @click="buscarRelatorios"
                    ></sigfoco-tooltip>
                    <sigfoco-tooltip
                        text="Limpar"
                        icon="mdi-eraser"
                        @click="resetForm"
                    ></sigfoco-tooltip>
                </v-col>
            </div>
        </v-form>
        <v-data-table
          v-if="form.mostrarAnalitico"
          class="mt-5 printable"
          :headers="getFilteredHeader(headersAnalitico)"
          :items="form.lists.listRelatorioAnalitico"
          :items-per-page="form.itemsPerPage"
          :footer-props="$footerProps"
        >
          <template v-slot:[`item.gre`]="{ item }">
            {{ item.gre }}
          </template>
          <template v-slot:[`item.disciplinaAnalitico`]="{ item }">
            {{ item.disciplinaAnalitico }}
          </template>
          <template v-slot:[`item.tipoDisciplina`]="{ item }">
            {{ item.tipoDisciplina }}
          </template>
          <template v-slot:[`item.situacao`]="{ item }">
            <sigfoco-label-ativo-inativo :ativo="item.situacao === 'Ativo'"></sigfoco-label-ativo-inativo>
          </template>
        </v-data-table>
        <v-data-table
            v-else
            class="mt-5 printable"
            :headers="getFilteredHeader(headersSintetico)"
            :items="form.lists.listRelatorioSintetico"
            :items-per-page="form.itemsPerPage"
            :footer-props="$footerProps"
        >
            <template v-slot:[`item.disciplinaSintetico`]="{ item }">
            {{ item.disciplinaSintetico }}
            </template>
            <template v-slot:[`item.cargaHoraria`]="{ item }">
            {{ item.cargaHoraria }}
            </template>
            <template v-slot:[`item.qtdFormacoes`]="{ item }">
            {{ item.qtdFormacoes }}
            </template>
            <template v-slot:[`item.qtdPrevistas`]="{ item }">
            {{ item.qtdPrevistas }}
            </template>
            <template v-slot:[`item.qtdPresentes`]="{ item }">
            {{ item.qtdPresentes }}
            </template>
            <template v-slot:[`item.qtdAusentes`]="{ item }">
            {{ item.qtdAusentes }}
            </template>
        </v-data-table>
        <sigfoco-buttons
          v-if="form.lists.listRelatorioAnalitico.length > 0 || form.lists.listRelatorioSintetico.length > 0"
          actionText="Baixar PDF"
          cancelText="Baixar CSV"
          @click="baixarRelatorioPdf"
          @cancel="baixarCSVRelatorio"
        ></sigfoco-buttons>
      </v-container>
    </div>
  </template>
  
<script>
import pageLoadingMixin from "mixins/page-loading.mixin";
import RelatorioSinteticoAnalitico from "services/relatorios-sintetico-analiticos/solicitacao-formacao.service";
import ManterSetorService from "~/services/manter-setor.service";
import FormacaoService from "~/services/manter-formacao.service";    
import DisciplinaService from "~/services/manter-disciplina.service";    
export default {
    name: "RelatorioSolicitacaoFormacaoPorEscola",
    mixins: [pageLoadingMixin, RelatorioSinteticoAnalitico, ManterSetorService, FormacaoService, DisciplinaService],
    data: () => ({
    onReport: false,
    expanded: [],
    form: {
        filters: {
            analitico: true,
            // analitico
            greIdAnalitico: null,
            disciplinaAnalitico: null,
            tipoDisciplinaAnalitico: null,
            dataInicioAnalitico: null,
            dataFimAnalitico: null,
            situacao: null,
            // sintetico
            disciplinaSintetico: null,
            dataInicioSintetico: null,
            dataFimSintetico: null,
        },
        lists: {
            listRelatorios: [],
            listRelatorioAnalitico: [],
            listRelatorioSintetico: [],
            listaGerenciasRegionais: [],
            tiposDeDisciplina: [],
            listaDisciplinas: [],
        },
        itemsPerPage: 10,
        geradorRelatorio: null,
        horaDaGeracao: null,
        totalSolicitacaoFormacao: 0,
        mostrarAnalitico: true,
    },
    headersAnalitico: [
        { text: "GRE", align: "center", value: "gre" },
        { text: "Disciplina", align: "center", value: "disciplina" },
        { text: "Tipo de Disciplina", align: "center", value: "tipoDisciplina" },
        { text: "Situação", align: "center", value: "situacao" },
    ],
    headersSintetico: [
        { text: "Disciplina", align: "center", value: "disciplina" },
        { text: "Quantidade de Formações", align: "center", value: "qtdFormacoes" },
        { text: "Quantidade Prevista de Participantes", align: "center", value: "qtdPrevistas" },
        { text: "Quantidade de Participantes Presentes", align: "center", value: "qtdPresentes" },
        { text: "Quantidade de Participantes Ausentes", align: "center", value: "qtdAusentes" },
    ],
    }),
    watch: {
        "form.filters.analitico"(novoValor) {
            this.form.mostrarAnalitico = novoValor;
            this.resetForm();
        }
    },

    computed: {
        isAnalitico() {
            return this.form.filters.analitico;
        },
    },
    methods: {
    getFilteredHeader(headers) {
        return headers.filter(header => {
        if (header.onlyView) return !this.onReport;
        if (header.onlyReport) return this.onReport;
        return true;
        });
    },
    buscarRelatorios() {
        const isValid = this.validarDatas();
        if (!isValid) return;
        const preparedRequest = this.prepararRequisicao();
            const buscarRelatorio = (request) => {
            return this.$obterRelatorioAnaliticoFormacoesPorDisciplina(request);
            };
            buscarRelatorio(this.$montarParamsFilters(preparedRequest)).then(
            ({ data }) => {
                this.form.mostrarAnalitico = this.isAnalitico;
                this.form.geradorRelatorio = data.relatorio.geradorRelatorio;
                this.form.horaDaGeracao = data.relatorio.horaDaGeracao;
                this.isAnalitico ? this.form.lists.listRelatorioAnalitico = data.relatorio?.listaAnalitico : this.form.lists.listRelatorioSintetico = data.relatorio?.listaSintetico; 
            }
        );
    },
    validarDatas() {
        const { dataInicioAnalitico, dataFimAnalitico, dataInicioSintetico, dataFimSintetico } = this.form.filters;
        const msgData = "A Data Início precisa ser anterior ou igual à Data Final";
        if (dataInicioAnalitico && dataFimAnalitico) {
            if (new Date(dataInicioAnalitico) > new Date(dataFimAnalitico)) {
                this.$notifyWarning(msgData);
                return false;
            }
        }
        if (dataInicioSintetico && dataFimSintetico) {
            if (new Date(dataInicioSintetico) > new Date(dataFimSintetico)) {
                this.$notifyWarning(msgData);
                return false;
            }
        }

        return true;
    },
    async baixarCSVRelatorio() { 
        const preparedRequest = this.prepararRequisicao();
        this.showPageLoading();
        try {
            const { data } = await (this.$obterRelatorioAnaliticoCSVFormacoesPorDisciplina(this.$montarParamsFilters(preparedRequest))
            );
            this.$baixarRelatorioCSV(data, `SIGFOCO.RelatórioDeDeFormaçãoPorEscola`);
            this.$notifySuccess("Operação realizada com sucesso.");
        } finally {
            this.hidePageLoading();
        }
    },

    async baixarRelatorioPdf() {
        const preparedRequest = this.prepararRequisicao();
        this.showPageLoading();
        try {
            const { data } = await (this.$obterRelatorioAnaliticoPDFFormacoesPorDisciplina(this.$montarParamsFilters(preparedRequest)));

            const url = URL.createObjectURL(data);
            const link = document.createElement("a");
            link.href = url;
            link.setAttribute("download", "SIGFOCO.RelatórioDeFormaçõesPorDisciplina.pdf");
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);

            this.$notifySuccess("Operação realizada com sucesso.");
        } finally {
            this.hidePageLoading();
        }
    },

    prepararRequisicao() {
        if (this.isAnalitico) {
        return {
            greId: this.form.filters.greIdAnalitico?.codigo,
            disciplinaId: this.form.filters.disciplinaAnalitico,
            tipoDisciplinaId: this.form.filters.tipoDisciplinaAnalitico,
            dataInicio: this.form.filters.dataInicioAnalitico,
            dataFim: this.form.filters.dataFimAnalitico,
            isAnalitico: this.isAnalitico,
            situacao: this.form.filters.situacao,
        };
        } else {
        return {
            disciplinaId: this.form.filters.disciplinaSintetico,
            dataInicio: this.form.filters.dataInicioSintetico,
            dataFim: this.form.filters.dataFimSintetico,
            isAnalitico: this.isAnalitico,
        };
        }
    },
    resetForm() {
        this.form.filters.dataInicioAnalitico = null;
        this.form.filters.dataFimAnalitico = null;
        this.form.filters.dataInicioSintetico = null;
        this.form.filters.dataFimSintetico = null;

        this.$nextTick(() => {
        this.$set(this.form.filters, 'dataInicioAnalitico', null);
        this.$set(this.form.filters, 'dataFimAnalitico', null);
        this.$set(this.form.filters, 'dataInicioSintetico', null);
        this.$set(this.form.filters, 'dataFimSintetico', null);
        });
        // analitico
        this.form.filters.greIdAnalitico = null;
        this.form.filters.disciplinaAnalitico = null;
        this.form.filters.tipoDisciplinaAnalitico = null;
        this.form.filters.situacao = null;

        // sintetico
        this.form.filters.disciplinaSintetico = null;
        this.form.lists.listRelatorioAnalitico = [];
        this.form.lists.listRelatorioSintetico = [];
    }
    },
    mounted() {
        this.$obterListaGerenciasRegionais().then(({ data }) => {
            this.form.lists.listaGerenciasRegionais = data.lista;
        });
        this.$buscarTipoDeDisciplina().then(({ data }) => {
            this.form.lists.tiposDeDisciplina = data.lista;
        });
        this.$buscarDisciplina().then(({ data }) => {
            this.form.lists.listaDisciplinas = data.lista;
        });  
    }
};
</script>
<style scoped>
.permissoes {
  padding: 1em !important;
  text-align: center;
  font-weight: 500;
}
.permissao {
  padding-right: 0.5em;
}
</style>